/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable @typescript-eslint/no-unused-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-misused-promises */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable no-unsafe-optional-chaining */
import type {ChangeEvent, MouseEvent} from 'react';
import {useMemo, useEffect, useState} from 'react';
import {useNavigate, useLocation} from 'react-router-dom';
import groupBy from 'lodash/groupBy';
import {Builder} from 'xml2js';
import {toast} from 'react-toastify';
// eslint-disable-next-line import/named
import {confirmAlert} from 'react-confirm-alert';

import type {FilterI, Xml2Js, ReMap} from 'interfaces';
import LayoutMain from 'components/Layouts/LayoutMain';
import ModalPolicyView from './components/ModalPolicyView';
import {
	exportDataToXml,
	hasExactRole,
	transformConditionsXML,
	transformActionsXML,
	parseConditionsFromXML,
	parseActionsFromXML,
} from 'utils';
import {usePostUpload} from 'hooks';
import ModalPolicyCreateOrEditXML from './components/ModalPolicyCreateOrEditXML';
import {API_BASE_URL} from 'config';
import {useAppSelector} from 'store/hooks';

export interface Filter {
	id: number;
	name: string;
	$?: FilterI;
}

const PolicyViewOrEdit = () => {
	const {roles} = useAppSelector(state => state.user);

	const isReadOnly = hasExactRole(roles, 'policy_engine_read_only');

	const isEdit = true;
	const navigate = useNavigate();
	const location = useLocation();

	const XMLJson = useMemo(() => {
		if (location.state) {
			return location.state.XMLJson || [];
		}
		return [];
	}, [location.state]);

	const activePolicy = useMemo(() => {
		if (location.state) {
			return location.state.activePolicy;
		}
		return {
			title: '',
			version: '',
			description: '',
		};
	}, [location.state]);

	const builder = new Builder();

	const [DATA, setDATA] = useState<Xml2Js>();
	const [selectedRow, setSelectedRow] = useState<Xml2Js | null>();
	const [selectedRowId, setSelectedRowId] = useState<null | number>(null);
	const [title, setTitle] = useState(activePolicy?.title);
	const [description, setDescription] = useState(activePolicy?.description);
	const [XMLParse, setXMLParse] = useState('');
	const [showModalRow, setShowModalRow] = useState(false);
	const [keyModal, setKeyModal] = useState<'Gw' | 'App'>('Gw');
	const [fullXML, setFullXML] = useState('');

	const {fetchUpload} = usePostUpload();

	const handleShowModalRow = (key?: 'Gw' | 'App') => {
		if (key) {
			setKeyModal(key);
		}
		setShowModalRow(prevState => !prevState);
	};

	/* Grouping the XMLJson by the scope. */
	useEffect(() => {
		const policyTmp = XMLJson.map((el: any) => ({
			...el,
			conditions:
				el?.conditions?.length > 0
					? parseConditionsFromXML(el.conditions) || [{}]
					: [{}],
			actions:
				el?.actions?.length > 0 ? parseActionsFromXML(el.actions) || {} : {},
		}));

		const groupXmlData = groupBy(policyTmp, xml => {
			if (xml.$ !== undefined) {
				return xml.$.scope;
			}
		});

		setDATA(groupXmlData as never);
		setFullXML(policyTmp as never);
	}, [XMLJson]);

	/**
	 * This function adds a row to a specific key in a JSON object and updates the state with the new
	 * data.
	 * @param {Xml2Js} row - The `row` parameter is of type `Xml2Js` and represents the data that needs to be
	 * added to the JSON object.
	 * @param {'Gw' | 'App'} key - The `key` parameter is a string literal type that can only have the
	 * values `'Gw'` or `'App'`. It is used to determine which property of the `DATA` object to push the
	 * `row` into.
	 */
	const handleAddRowInJSON = (
		row: Xml2Js,
		key: 'Gw' | 'App',
		isEditRow = false,
	) => {
		const datas = DATA && DATA[keyModal] ? [...DATA[keyModal]] : [];

		if (isEditRow) {
			const tmp = datas.map((el: Xml2Js, idx: number) => {
				if (idx === selectedRowId) {
					el = row;
				}
				return el;
			});

			const union = {...DATA, [key]: tmp};

			const finalData = [];

			if (union && 'Gw' in union) {
				union.Gw && finalData.push(...union.Gw);
			}

			if (DATA && 'App' in union) {
				union.App && finalData.push(...union.App);
			}

			setDATA(prev => ({...prev, [key]: tmp} as never));
			setFullXML(finalData as never);
			return;
		}

		datas?.push(row);
		setDATA(prev => ({...prev, [key]: datas} as never));

		const union = {...DATA, [key]: datas};

		const finalData = [];

		if (union && 'Gw' in union) {
			union.Gw && finalData.push(...union.Gw);
		}

		if (DATA && 'App' in union) {
			union.App && finalData.push(...union.App);
		}

		setFullXML(finalData as never);
	};

	/**
	 * This function updates the enabled status of an item in a list based on a checkbox input.
	 * @param e - The `e` parameter is an event object of type `ChangeEvent<HTMLInputElement>`. It is
	 * triggered when the checkbox input is changed.
	 * @param {Xml2Js} item - Xml2Js is likely a custom type or interface defined elsewhere in the
	 * codebase. It is being used as a type for the `item` parameter in the `handleChangeCheckbox` function.
	 * Without knowing the specific implementation of Xml2Js, it is difficult to provide more information
	 * about what it represents.
	 * @param {'Gw' | 'App'} key - The `key` parameter is a string literal type that can only have the
	 * values `'Gw'` or `'App'`. It is used to determine which property of the `DATA` object to access and
	 * modify.
	 */
	const handleChangeCheckbox = (
		e: ChangeEvent<HTMLInputElement>,
		item: Xml2Js,
		key: 'Gw' | 'App',
	) => {
		const Datas = key === 'Gw' ? DATA?.Gw : DATA?.App;

		const tmp = Datas.filter((res: Xml2Js) => {
			if (res.$.name === item.$.name) {
				res.$.enabled = e.target.checked.toString();
			}
			return res;
		});
		setDATA(prev => ({...prev, [key]: tmp} as never));
	};

	/**
	 * This is a TypeScript React function that sets the title based on the value of an input element when
	 * it changes.
	 * @param e - The parameter "e" is of type ChangeEvent<HTMLInputElement>, which is an event object
	 * that is triggered when the value of an input element is changed. It contains information about the
	 * event, such as the target element and the new value of the input. In this case, the function is
	 * using the event
	 */
	const handleChange = (e: ChangeEvent<HTMLInputElement>) =>
		setTitle(e.target.value);

	const handleChangeDescription = (e: ChangeEvent<HTMLInputElement>) =>
		setDescription(e.target.value);

	/**
	 * This function returns an object with options for a confirmation modal to remove a policy.
	 * @param {Xml2Js} item - The item parameter is of type Xml2Js and represents the policy that the user
	 * wants to remove.
	 * @param {'Gw' | 'App'} key - The `key` parameter is a string that specifies which type of policy is
	 * being removed. It can either be `'Gw'` or `'App'`.
	 */
	const optionsRemoveModal = (item: Xml2Js, key: 'Gw' | 'App') => ({
		title: 'Do you really want to delete this record?',
		message: 'This action can not be undone.',
		buttons: [
			{
				label: 'Yes',
				onClick: () => {
					handleRemoveRow(item, key);
				},
			},
			{
				label: 'No',
			},
		],
		closeOnEscape: true,
		closeOnClickOutside: true,
		keyCodeForClose: [8, 32],
	});

	/**
	 * This function removes a row from a specific data object based on the item's name and updates the
	 * state.
	 * @param {Xml2Js} item - The `item` parameter is of type `Xml2Js` and is used as a reference to the
	 * specific item that needs to be removed from the `Datas` array. It is assumed that `Xml2Js` is a
	 * custom type defined elsewhere in the codebase.
	 * @param {'Gw' | 'App'} key - The `key` parameter is a string literal type that can only have the
	 * values `'Gw'` or `'App'`. It is used to determine which property of the `DATA` object to access and
	 * modify.
	 */
	const handleRemoveRow = (item: Xml2Js, key: 'Gw' | 'App') => {
		const Datas = key === 'Gw' ? DATA?.Gw : DATA?.App;

		const tmp = Datas.filter(
			(res: Filter) => res.$ && res.$.name !== item.$.name,
		);

		setDATA(prev => ({...prev, [key]: tmp} as never));
	};

	const optionsSubmit = (e: MouseEvent<HTMLElement>) => {
		e.preventDefault();
		return {
			title: 'Do you want to save the XML modifications?',
			message: 'This action will create a new version.',
			buttons: [
				{
					label: 'Yes',
					onClick: async () => {
						await handleSubmit(e);
					},
				},
				{
					label: 'No',
				},
			],
			closeOnEscape: true,
			closeOnClickOutside: true,
			keyCodeForClose: [8, 32],
		};
	};

	/**
	 * This function handles a form submission event and logs a message to the console.
	 * @param e - The parameter "e" is an event object of type MouseEvent<HTMLElement>. It is passed as an
	 * argument to the handleSubmit function. The event object contains information about the event that
	 * triggered the function, such as the type of event, the target element, and any additional data
	 * related to the event. In
	 */
	const handleSubmit = async (e: MouseEvent<HTMLElement>) => {
		e.preventDefault();
		try {
			// merge data
			const finalData = [];

			if (DATA?.Gw && Array.isArray(DATA.Gw) && DATA.Gw.length > 0) {
				finalData.push(
					...DATA.Gw.map(item => ({
						...item,
						conditions: item.conditions
							? transformConditionsXML(item.conditions)
							: [],
						actions: item.actions ? transformActionsXML(item.actions) : [{}],
					})),
				);
			}

			if (DATA?.App && Array.isArray(DATA.App) && DATA.App.length > 0) {
				finalData.push(
					...DATA.App.map(item => ({
						...item,
						conditions: item.conditions
							? transformConditionsXML(item.conditions)
							: [],
						actions: item.actions ? transformActionsXML(item.actions) : [{}],
					})),
				);
			}

			if (!finalData.length) {
				toast.warning('You must add at least one policy to be able to save.');
				return;
			}

			const titleFile = title.split(' ').join('');

			// parse json to xml
			const XML = builder.buildObject({
				policySet: {policy: finalData},
			}) as never;

			const formData = new FormData();
			formData.append(
				'file',
				// created blob for upload file
				new Blob([XML], {type: 'text/xml'}),
				`${titleFile}.xml`,
			);
			formData.append('title', title);
			formData.append('description', description);
			await fetchUpload(
				`${API_BASE_URL}/policy-engine-mgmt/v1/policy-set`,
				formData,
			);

			toast.success('Created Successfully!');

			navigate(-1);
		} catch (error: any) {
			const {data} = error.response;
			toast.error(data.detail || data);
		}
	};

	const getPreOrPost = (reMap: ReMap) => {
		if (reMap?.$?.pre) {
			return JSON.parse(reMap.$.pre) ? '(pre)' : '(post)';
		}
		return 'post';
	};

	return (
		<LayoutMain>
			<div className="container-fluid">
				<div className="row">
					<div className="col-md-12">
						<h1 className="mt-2">Policies Set Details</h1>
					</div>
				</div>

				<nav aria-label="breadcrumb">
					<ol className="breadcrumb">
						<li className="breadcrumb-item">
							<span
								role="button"
								className="text-primary"
								onClick={() => navigate(-1)}>
								Policy
							</span>
						</li>
						<li className="breadcrumb-item active" aria-current="page">
							Policies Set Details
						</li>
					</ol>
				</nav>

				<form
					className="card-tasks card h-100"
					onSubmit={e => confirmAlert(optionsSubmit(e as never))}>
					<div className="card-header">
						<div className="row">
							{/* col inputs */}
							<div className="col-md-6">
								<div className="row mb-4">
									<div className="col-md-6">
										<label className="font-weight-bold text-dark">Title</label>
										<input
											type="text"
											className="form-control"
											id="title"
											disabled={!isEdit || isReadOnly}
											placeholder="Policy Set"
											required
											name="title"
											value={title}
											onChange={handleChange}
										/>
										<div className="invalid-feedback">
											Valid Title is required.
										</div>
									</div>
									<div className="col-md-6">
										<label className="font-weight-bold text-dark">
											Version
										</label>
										<input
											type="text"
											className="form-control"
											id="version"
											defaultValue={activePolicy?.version}
											readOnly
											placeholder="Version"
											required
										/>
										<div className="invalid-feedback">
											Valid version is required.
										</div>
									</div>
								</div>
								{/*
								<div className="row">
									<div className="col-md-12">
										<label className="font-weight-bold text-dark">
											Mappings Referenced
										</label>
										<input
											type="text"
											className="form-control mt-1"
											id="title"
											value=""
											placeholder="Roaming-Arps, MVNOs-QCIs,SMSTextsLang,SMSCredit"
											required
											readOnly={!isEdit}
											disabled
										/>
										<div className="invalid-feedback">
											Valid Title name is required.
										</div>
									</di
								</div>
								*/}
							</div>

							{/* col textarea */}
							<div className="col-md-6">
								<label className="font-weight-bold text-dark">
									Changes Description
								</label>
								<input
									type="textarea"
									className="form-control"
									id="description"
									disabled={!isEdit || isReadOnly}
									required
									name="description"
									value={description}
									onChange={handleChangeDescription}
								/>
								<div className="invalid-feedback">
									Please enter a description.
								</div>
							</div>
						</div>
					</div>

					<div className="card-body pt-0 mt-n4">
						<div className="row">
							{/* Scope GW */}
							<div className="col-md-6 mt-5 table-responsive cypress-policyContainer">
								<div className="d-flex justify-content-between">
									<label className="font-weight-bold text-dark">Scope Gw</label>

									{!isReadOnly && (
										<button
											type="button"
											onClick={() => {
												setSelectedRow(null);
												handleShowModalRow('Gw');
											}}
											className="border-0 bg-transparent d-inline">
											<i
												className="bi-1 bi-plus-square"
												title=""
												data-toggle="tooltip"
												data-original-title="Create"
											/>
										</button>
									)}
								</div>

								<table className="table table-hover table-sm">
									<thead className="table-light">
										<tr>
											<th scope="col">Priority</th>
											<th scope="col">Enabled</th>
											<th scope="col">Name</th>
											<th scope="col">Mapping Reference</th>
											{!isReadOnly && (
												<th scope="col" className="text-center">
													Edit
												</th>
											)}
											<th scope="col" className="text-center">
												Download
											</th>
											<th scope="col" className="text-center">
												XML View
											</th>
											{!isReadOnly && (
												<th scope="col" className="text-center">
													Delete
												</th>
											)}
										</tr>
									</thead>
									<tbody>
										{DATA &&
											DATA.hasOwnProperty('Gw') &&
											DATA?.Gw?.map((item: Xml2Js, index: number) => ({
												item,
												indexOrigin: index,
											}))
												.slice()
												.sort(
													(a: any, b: any) =>
														Number(b.item.$.priority) -
														Number(a.item.$.priority),
												)
												.map((el: any) => (
													<tr key={el.indexOrigin}>
														<td
															scope="row"
															width={10}
															className="font-weight-bold">
															{el.item.$.priority}
														</td>
														<td width={20} className="text-center pl-4">
															<input
																className="form-check-input"
																type="checkbox"
																checked={JSON.parse(el.item.$.enabled)}
																id="flexCheckDefault"
																disabled={!isEdit || isReadOnly}
																onChange={e =>
																	handleChangeCheckbox(e, el.item, 'Gw')
																}
																name="gw"
																value={JSON.parse(el.item.$.enabled)}
															/>
														</td>
														<td>{el.item.$.name}</td>
														<td>
															{'transformations' in el.item &&
															Array.isArray(el?.item?.transformations) &&
															el?.item?.transformations.length > 0 &&
															Array.isArray(el.item.transformations[0]?.ReMap)
																? el.item?.transformations?.[0]?.ReMap.map(
																		(reMap: ReMap, idx: number) => (
																			<div key={idx}>
																				{typeof reMap === 'string'
																					? `(post)-${reMap}`
																					: `${getPreOrPost(reMap)}-${reMap._}`}
																			</div>
																		),
																  )
																: '-'}
														</td>
														{!isReadOnly && (
															<td width={10} className="text-center">
																<button
																	type="button"
																	className="border-0 bg-transparent d-inline"
																	onClick={() => {
																		setSelectedRowId(el.indexOrigin);
																		setSelectedRow(el.item as never);
																		handleShowModalRow('Gw');
																	}}>
																	<i
																		className={`bi-1 ${
																			isReadOnly ? 'bi-eye' : 'bi-pencil'
																		}`}
																		title="Edit"
																	/>
																</button>
															</td>
														)}
														<td width={10} className="text-center">
															<button
																type="button"
																className="border-0 bg-transparent d-inline"
																onClick={() => {
																	let actions = [];
																	let conditions: any = [];
																	if (el.item?.actions !== undefined) {
																		actions = transformActionsXML(
																			el?.item?.actions,
																		);
																	} else {
																		actions = [{}];
																	}

																	if (
																		el.item?.conditions?.some(
																			(el: any) => Object.keys(el)?.length > 0,
																		)
																	) {
																		conditions = transformConditionsXML(
																			el?.item?.conditions,
																		);
																	} else {
																		conditions = [{}];
																	}

																	exportDataToXml(
																		builder.buildObject({
																			policy: {...el.item, conditions, actions},
																		}) as never,
																		el.item.$.name,
																	);
																}}>
																<i
																	className="bi-1 bi-download"
																	title=""
																	data-toggle="tooltip"
																	data-original-title="Download"
																/>
															</button>
														</td>
														<td width={80} className="text-center">
															<button
																type="button"
																className="border-0 bg-transparent d-inline"
																data-toggle="modal"
																data-target="#modalPolicyView"
																onClick={() => {
																	let actions = [];
																	let conditions: any = [];

																	if (el.item?.actions !== undefined) {
																		actions = transformActionsXML(
																			el?.item?.actions,
																		);
																	} else {
																		actions = [{}];
																	}

																	if (
																		el.item?.conditions?.some(
																			(el: any) => Object.keys(el)?.length > 0,
																		)
																	) {
																		conditions = transformConditionsXML(
																			el?.item?.conditions,
																		);
																	} else {
																		conditions = [{}];
																	}

																	setXMLParse(
																		builder.buildObject({
																			policy: {...el.item, conditions, actions},
																		}) as never,
																	);
																}}>
																<i
																	className="bi-1 bi-filetype-xml"
																	title=""
																	data-toggle="tooltip"
																	data-original-title="XML View"
																/>
															</button>
														</td>
														{!isReadOnly && (
															<td width={20} className="text-center">
																<button
																	type="button"
																	className="border-0 bg-transparent d-inline"
																	onClick={() =>
																		confirmAlert(
																			optionsRemoveModal(el.item, 'Gw'),
																		)
																	}>
																	<i className="bi-1 bi-trash-fill text-danger" />
																</button>
															</td>
														)}
													</tr>
												))}
									</tbody>
								</table>
							</div>

							{/* Scope App */}
							<div className="col-md-6 mt-5 table-responsive">
								<div className="d-flex justify-content-between">
									<label className="font-weight-bold text-dark">
										Scope App
									</label>

									{!isReadOnly && (
										<button
											type="button"
											onClick={() => {
												setSelectedRow(null);
												handleShowModalRow('App');
											}}
											className="border-0 bg-transparent d-inline">
											<i
												className="bi-1 bi-plus-square"
												title=""
												data-toggle="tooltip"
												data-original-title="Create"
											/>
										</button>
									)}
								</div>

								<table className="table table-hover table-sm">
									<thead className="table-light">
										<tr>
											<th scope="col">Priority</th>
											<th scope="col">Enabled</th>
											<th scope="col">Name</th>
											<th scope="col">Mapping Reference</th>
											{!isReadOnly && (
												<th scope="col" className="text-center">
													Edit
												</th>
											)}
											<th scope="col" className="text-center">
												Download
											</th>
											<th scope="col" className="text-center">
												XML View
											</th>
											{!isReadOnly && (
												<th scope="col" className="text-center">
													Delete
												</th>
											)}
										</tr>
									</thead>
									<tbody>
										{DATA &&
											DATA.hasOwnProperty('App') &&
											DATA?.App?.map((item: Xml2Js, index: number) => ({
												item,
												indexOrigin: index,
											}))
												.slice()
												.sort(
													(a: any, b: any) =>
														Number(b.item.$.priority) -
														Number(a.item.$.priority),
												)
												.map((el: any) => (
													<tr key={el.indexOrigin}>
														<td
															scope="row"
															width={10}
															className="font-weight-bold">
															{el.item.$.priority}
														</td>
														<td width={20} className="text-center pl-4">
															<input
																className="form-check-input"
																type="checkbox"
																checked={JSON.parse(el.item.$.enabled)}
																id="flexCheckDefault"
																disabled={!isEdit || isReadOnly}
																onChange={e =>
																	handleChangeCheckbox(e, el.item, 'App')
																}
																name="app"
																value={JSON.parse(el.item.$.enabled)}
															/>
														</td>
														<td>{el.item.$.name}</td>
														<td>
															{'transformations' in el.item &&
															Array.isArray(el?.item?.transformations) &&
															el?.item?.transformations.length > 0 &&
															Array.isArray(el.item.transformations[0]?.ReMap)
																? el.item?.transformations?.[0]?.ReMap.map(
																		(reMap: ReMap, idx: number) => (
																			<div key={idx}>
																				{typeof reMap === 'string'
																					? `(post)-${reMap}`
																					: `${getPreOrPost(reMap)}-${reMap._}`}
																			</div>
																		),
																  )
																: '-'}
														</td>
														{!isReadOnly && (
															<td width={10} className="text-center">
																<button
																	type="button"
																	className="border-0 bg-transparent d-inline"
																	onClick={() => {
																		setSelectedRowId(el.indexOrigin);
																		setSelectedRow(el.item as never);
																		handleShowModalRow('App');
																	}}>
																	<i
																		className={`bi-1 ${
																			isReadOnly ? 'bi-eye' : 'bi-pencil'
																		}`}
																		title="Edit"
																	/>
																</button>
															</td>
														)}
														<td width={10} className="text-center">
															<button
																type="button"
																className="border-0 bg-transparent d-inline"
																onClick={() => {
																	let actions = [];
																	let conditions: any = [];
																	if (el.item?.actions !== undefined) {
																		actions = transformActionsXML(
																			el?.item?.actions,
																		);
																	} else {
																		actions = [{}];
																	}

																	if (
																		el.item?.conditions?.some(
																			(el: any) => Object.keys(el)?.length > 0,
																		)
																	) {
																		conditions = transformConditionsXML(
																			el?.item?.conditions,
																		);
																	} else {
																		conditions = [{}];
																	}

																	exportDataToXml(
																		builder.buildObject({
																			policy: {...el.item, conditions, actions},
																		}) as never,
																		el.item.$.name,
																	);
																}}>
																<i
																	className="bi-1 bi-download"
																	title=""
																	data-toggle="tooltip"
																	data-original-title="Download"
																/>
															</button>
														</td>
														<td width={80} className="text-center">
															<button
																type="button"
																className="border-0 bg-transparent d-inline"
																data-toggle="modal"
																data-target="#modalPolicyView"
																onClick={() => {
																	let actions = [];
																	let conditions: any = [];
																	if (el.item?.actions !== undefined) {
																		actions = transformActionsXML(
																			el?.item?.actions,
																		);
																	} else {
																		actions = [{}];
																	}

																	if (
																		el?.item.conditions?.some(
																			(el: any) => Object.keys(el)?.length > 0,
																		)
																	) {
																		conditions = transformConditionsXML(
																			el?.item?.conditions,
																		);
																	} else {
																		conditions = [{}];
																	}

																	setXMLParse(
																		builder.buildObject({
																			policy: {...el.item, conditions, actions},
																		}) as never,
																	);
																}}>
																<i
																	className="bi-1 bi-filetype-xml"
																	title=""
																	data-toggle="tooltip"
																	data-original-title="XML View"
																/>
															</button>
														</td>
														{!isReadOnly && (
															<td width={20} className="text-center">
																<button
																	type="button"
																	className="border-0 bg-transparent d-inline"
																	onClick={() =>
																		confirmAlert(
																			optionsRemoveModal(el.item, 'App'),
																		)
																	}>
																	<i className="bi-1 bi-trash-fill text-danger" />
																</button>
															</td>
														)}
													</tr>
												))}
									</tbody>
								</table>
							</div>

							<div className="col-md-12 mt-5">
								<div className="d-flex justify-content-end">
									<button
										type="button"
										className={`btn btn-light ${!isReadOnly ? 'mr-5' : ''}`}
										data-toggle="modal"
										data-target="#modalPolicyView"
										onClick={() => {
											const res: any = fullXML;
											const policyTmp = res.map((el: any) => {
												let actionsTmp = [];
												let conditions: any = [];

												if (el?.actions !== undefined) {
													actionsTmp = transformActionsXML(el?.actions);
												} else {
													actionsTmp = [{}];
												}

												if (
													el?.conditions?.some(
														(res: any) => Object.keys(res)?.length > 0,
													)
												) {
													conditions = transformConditionsXML(el?.conditions);
												} else {
													conditions = [{}];
												}

												return {...el, conditions, actions: actionsTmp};
											});

											setXMLParse(
												builder.buildObject({policySet: {policy: policyTmp}}),
											);
										}}>
										<i className="bi-1 bi-filetype-xml mr-2" /> View XML
									</button>

									{!isReadOnly && (
										<button type="submit" className="btn btn-primary">
											<i className="bi-1 bi-save mr-2" /> Save
										</button>
									)}
								</div>
							</div>
						</div>
					</div>
				</form>
			</div>

			<ModalPolicyView type="Policy" XMLParse={XMLParse} />

			<ModalPolicyCreateOrEditXML
				show={showModalRow}
				onAddRow={handleAddRowInJSON}
				onClose={handleShowModalRow}
				keyModal={keyModal}
				rowData={selectedRow as never}
			/>
		</LayoutMain>
	);
};

export default PolicyViewOrEdit;
